const awgWordsPerMinute = 225;

export function getWordCount(text: string): number {
  return text.trim().split(/\s+/).length;
}

export function timeToRead(wordCount: number): number {
  return Math.ceil(wordCount / awgWordsPerMinute);
}